//MAIN
export const USER_NAME = 'hosco_username';
export const CURRENT_BRANCH = 'branch';
export const TOKEN_KEY = 'TOKEN_KEY';
export const TENANT_INFO = 'hosco_tenantInfo';
export const TENANT_BASE_URL = 'tenant_base';
